import { render, staticRenderFns } from "./AppearanceSettings.vue?vue&type=template&id=451158ae&scoped=true"
import script from "./AppearanceSettings.vue?vue&type=script&lang=js"
export * from "./AppearanceSettings.vue?vue&type=script&lang=js"
import style0 from "./AppearanceSettings.vue?vue&type=style&index=0&id=451158ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451158ae",
  null
  
)

export default component.exports